import React from 'react';
import BSIPMigrationTable from '../bsip-migration-table/bsip-migration-table';
import './bsip-service-details.css';

const BSIPServiceDetails = (props) => {
  const
    {
      siteServices,
    } = props;
  const {
    serviceDetailsHeading,
  } = props.authorableContent;

  const siteServicesArray = [];

  siteServices.forEach((parentService) => {
    siteServicesArray.push({ type: parentService.type, number: parentService.number });

    if (parentService.primaryList && parentService.primaryList.length > 0) {
      parentService.primaryList.forEach((childService) => {
        siteServicesArray.push({ type: 'PrimaryFNN', number: childService.number });

        childService.auxList.forEach((auxService) => {
          siteServicesArray.push({ type: 'Auxillary', number: auxService });
        });
      });
    } else {
      parentService.auxList.forEach((auxService) => {
        siteServicesArray.push({ type: 'Auxillary', number: auxService });
      });
    }
  });


  return (
    <div className="bsip-service-section">
      <div className="row">
        <div className="col-12 pl-sm-0">
          <h2 id="service-heading" className="service-heading">{serviceDetailsHeading}</h2>
        </div>
      </div>
      <BSIPMigrationTable
        siteServicesArray={siteServicesArray}
        bsipServiceDetails={props.authorableContent}
      />
    </div>
  );
};

export default React.memo(BSIPServiceDetails);
